<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="formrow">
    <label class="form-label">Neues Passwort</label>
    <input type="password" formControlName="password" class="form-control"
      [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
    @if (submitted && f['password'].errors) {
      <div class="invalid-feedback">
        @if (f['password'].errors['required']) {
          <div>Neues Passwort ist Pflicht</div>
        }
        @if (f['password'].errors['minlength']) {
          <div>Dein Passwort muss mindestens 6 Zeichen haben</div>
        }
      </div>
    }
  </div>
  <div class="formrow">
    <button>NEUES PASSWORT SETZEN</button>
  </div>
  <div class="formrow">
    <a routerLink="/">ZURÜCK ZUM LOGIN?</a>
  </div>
</form>